
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Osserman",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Osserman.vue